import { render, staticRenderFns } from "./EntitlementList.vue?vue&type=template&id=c81a4788&"
import script from "./EntitlementList.vue?vue&type=script&lang=ts&"
export * from "./EntitlementList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c81a4788')) {
      api.createRecord('c81a4788', component.options)
    } else {
      api.reload('c81a4788', component.options)
    }
    module.hot.accept("./EntitlementList.vue?vue&type=template&id=c81a4788&", function () {
      api.rerender('c81a4788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/entitlements/EntitlementList.vue"
export default component.exports